<nz-card *ngIf="hasData" [nzTitle]="cardTitle" [nzBodyStyle]="{ padding: 0 }">
  <ng-template #cardTitle>
    <app-lot-moto-jupiter-inspection-card-title
      [inspectionInfo]="inspectionInfo"
    ></app-lot-moto-jupiter-inspection-card-title>
  </ng-template>

  <app-lot-moto-jupiter-inspection-card-slider
    *ngIf="hasImages"
    [images]="inspectionInfo.images"
    (noImages)="noImages()"
  ></app-lot-moto-jupiter-inspection-card-slider>

  <app-lot-moto-jupiter-inspection-card-notes
    *ngIf="hasNotes"
    [notes]="inspectionInfo.notes"
  ></app-lot-moto-jupiter-inspection-card-notes>
</nz-card>
